import { EventStatus } from "app/utils/const";
import cx from "classnames";
import type { Element } from "React";
import type { Node } from "react";
import { Component } from "react";
import "./Collapsible.scss";
type Props = {
  status?: string;
  suspended?: Node;
  header: Node;
  content: Node;
  onToggle?: (...args: Array<any>) => any;
  isActive: boolean;
  withArrows?: boolean;
  disableAnimations?: boolean;
};

class Collapsible extends Component<Props> {
  render(): Element<"div"> {
    const {
      status,
      suspended,
      header,
      content,
      onToggle,
      withArrows,
      disableAnimations,
    } = this.props;
    let isActive = this.props.isActive;

    if (isActive === undefined) {
      // we want the collapsible open by default
      // so unless specifically set to false, set true
      isActive = true;
    }

    const showOverlay =
      status === EventStatus.SUSPENDED.toLowerCase() ||
      status === EventStatus.GRADED.toLowerCase() ||
      status === EventStatus.CLOSED.toLowerCase();
    let statusCssClass = "";

    if (status != null) {
      switch (status) {
        case EventStatus.SUSPENDED.toLowerCase():
          statusCssClass = EventStatus.SUSPENDED.toLowerCase();
          break;

        case EventStatus.GRADED.toLowerCase():
          statusCssClass = EventStatus.SUSPENDED.toLowerCase();
          break;

        case EventStatus.CLOSED.toLowerCase():
          statusCssClass = EventStatus.SUSPENDED.toLowerCase();
          break;

        default:
          statusCssClass = status;
          break;
      }
    } else {
      statusCssClass = "";
    }

    return (
      <div
        className={cx(`collapsible ${statusCssClass}`, {
          "collapsible--active": isActive,
        })}
      >
        {showOverlay ? suspended : ""}
        <div
          className={cx("collapsible__header", {
            "collapsible__header--with-arrows": withArrows,
            "collapsible__header--with-arrows--up": withArrows && isActive,
            "collapsible__header--with-arrows--down": withArrows && !isActive,
          })}
          onClick={onToggle}
        >
          {header}
        </div>
        <div className="collapsible__content">
          <div
            className={cx("collapsible__content__inner", {
              "collapsible__content__inner--disable-animations":
                disableAnimations,
            })}
          >
            {content}
          </div>
        </div>
      </div>
    );
  }
}

export default Collapsible;
